'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*========================================================================================
                    CONTIENE TUTTE LE CLASSI UTILI NELLA SCHEDA PRODOTTO
 ========================================================================================*/

/**
 * Gestione estrazione prodotti raccomandati selezionati da shopify.
 *
 * L'estrazione viene eseguita solo se la section "section/product-recommendtions.liquid"
 * è stata caricata nel singolo template della scheda prodotto.
 *
 */
var ProductRecommendations = function () {
    /**
     *
     * @param {*} _dom Contenitore padre
     * @param {*} initOnCreate  = True esegue l'init alla creazione tramite NEW
     */
    function ProductRecommendations(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, ProductRecommendations);

        this.dom = _dom;

        //Costanti stato chimata Ajax
        this.GET_PRODUCT_STATUS_NOT_EXECUTE = 0; // La chiamata getProducts mai eseguita
        this.GET_PRODUCT_STATUS_SUCCESS = 1; // La chiamata getProducts è andata a buon fine
        this.GET_PRODUCT_STATUS_SUCCESS_NO_PRODUCTS = 2; // La chiamata getProducts è andata a buon fine ma non ci sono prodotti da mostrare
        this.GET_PRODUCT_STATUS_ERROR = 3; // La chiamata getProducts ha prodotto errori

        this.reset();

        if (initOnCreate === true) {
            this.init();
        }
    }

    /**
     * Provvede ad impostare i valori di default delle variabili, utile nel caso va fatto un reinit del componente
     */


    _createClass(ProductRecommendations, [{
        key: 'reset',
        value: function reset() {
            this.exists = false; //Indica se eiste l'oggetto ne dom .product-recommendations
            this.productRecommendationsSection = null;
            this.productId = 0;
            this.baseUrl = null;
            this.limit = 4;
            this.requestUrl = null;

            //0 =  non avviata , 1 = Prodotti caricati,  2 = Errore getProducts
            this.getProductsStatus = this.GET_PRODUCT_STATUS_NOT_EXECUTE;
            this.totalProducts = 0; //Totale di prodotti ritornati dalla getProducts

            //Risposta HTML della chimata AJAX per ottenere i prodotti
            this.htmlResponse = "";
        }

        /**
         * Reinizializzazione del componente
         */

    }, {
        key: 'reinit',
        value: function reinit() {
            this.reset();
            this.init();
        }
    }, {
        key: 'init',
        value: function init() {
            //Se non ho caricato la section non trovo l'oggetto ".product-recommendations" nel dom   quindi non posso voglio caricare i prodotti raccomandati
            this.productRecommendationsSection = $('.product-recommendations');
            if (this.productRecommendationsSection === null) {
                return;
            }
            //
            this.exists = true;

            //Variabili utili alla chimata ajax prelevate dai dataset
            this.productId = this.productRecommendationsSection.data('product-id');
            this.baseUrl = this.productRecommendationsSection.data('base-url');
            this.limit = this.productRecommendationsSection.data('limit');
            this.requestUrl = this.baseUrl + '?section_id=product-recommendations&product_id=' + this.productId + '&limit=' + this.limit;
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.exists;
        }

        /**
         * Verifica se posso visualizzare i prodotti raccomandati
         * * FALSE se non ho chiamato getProducts
         * * FALSE se getProducts non ha restituito prodotti raccomandati
         * * FALSE se la chiamata getProducts è andata in errore
         *
         * * TRUE solo se la chiamata getProducts è andata a buon fine e ci sono prodotti da mostrare
         */

    }, {
        key: 'canShow',
        value: function canShow() {
            return self.getProductsStatus == self.GET_PRODUCT_STATUS_SUCCESS_NO_PRODUCTS;
        }

        /**
         * Estrazione dei prodotti raccomandati tramite chiamata ajax con gestione eventi per triggerati sul dom passato nel costruttore
         */

    }, {
        key: 'getProducts',
        value: function getProducts() {
            if (!this.isExists) return;

            var self = this;
            this.dom.trigger('get-products-recommendations-before');

            $.get(this.requestUrl).done(function (data) {
                this.totalProducts = $(data).find('#related-product-grid').children().length;
                if (this.totalProducts == 0) {
                    self.getProductsStatus = self.GET_PRODUCT_STATUS_SUCCESS_NO_PRODUCTS;
                } else {
                    self.getProductsStatus = self.GET_PRODUCT_STATUS_SUCCESS;
                }

                self.htmlResponse = $(data).find('.product-recommendations').html();
                $('#related-recommendations').html(self.htmlResponse);
            }).fail(function (data) {
                this.totalProducts = 0;
                self.getProductsStatus = self.GET_PRODUCT_STATUS_ERROR;
                self.htmlResponse = $(data).html();
            }).always(function () {
                self.dom.trigger('get-products-recommendations-after', { status: self.getProductsStatus, count: this.totalProducts, message: self.htmlResponse });
            });
        }
    }]);

    return ProductRecommendations;
}();
/**
 * Gestione prodotti visti di recente salvati nei cookie
 */


var ProductRecentlyViewed = function () {
    /**
    *
    * @param {*} _dom Contenitore padre
    * @param {*} initOnCreate  = True esegue l'init alla creazione tramite NEW
    */
    function ProductRecentlyViewed(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, ProductRecentlyViewed);

        this.dom = _dom;

        this.COOKIE_NAME = 'RecentlyViewedSJ';

        //Costanti stato
        this.GET_PRODUCT_STATUS_NOT_EXECUTE = 0; // La chiamata getProducts mai eseguita
        this.GET_PRODUCT_STATUS_SUCCESS = 1; // La chiamata getProducts è andata a buon fine
        this.GET_PRODUCT_STATUS_SUCCESS_NO_PRODUCTS = 2; // La chiamata getProducts è andata a buon fine ma non ci sono prodotti da mostrare
        this.GET_PRODUCT_STATUS_ERROR = 3; // La chiamata getProducts ha prodotto errori
        this.GET_PRODUCT_STATUS_SUCCESS_AND_ERROR = 4; // La chiamata getProducts ha prodotto errori

        this.reset();

        if (initOnCreate === true) {
            this.init();
        }
    }

    _createClass(ProductRecentlyViewed, [{
        key: 'reset',
        value: function reset() {
            this.exists = false; // Identifica se l'oggetto è presente nel dom
            this.productRecentlyViewedHtmlElement = null; // Elememto HTML nel this.dom che identifica la presenza del blocco Visti di recente
            this.productHandle = null; // Handle del prodotto corrente se sto visualizzando la scheda PRODOTTO
            this.rvHandlesToDisplay = null; // Array di Handle da visualizzare
            this.limit = 4; // Numero massimo di prodotti da estrarre
        }
    }, {
        key: 'init',
        value: function init() {
            //Se non ho trovo un contenitore ".js-recently-viewed" nel dom non posso gestire i prodotti visti di recente
            this.productRecentlyViewedHtmlElement = this.dom.find('.js-recently-viewed');
            if (this.productRecentlyViewedHtmlElement === null) {
                return;
            }

            // Ho trovato il contenitore, quindi l'oggetto esiste
            this.exists = true;

            //0 =  non avviata , 1 = Prodotti caricati,  2 = Errore getProducts
            this.getProductsStatus = this.GET_PRODUCT_STATUS_NOT_EXECUTE;

            this.limit = this.getLimit();
            this.productHandle = this.getProductHandleFromScript();
            var rvHandles = this.getProductsHandleFromCookie();

            this.rvHandlesToDisplay = this.removeProductHandle(rvHandles, this.productHandle);

            //Salvo il nuovo cookie
            this.setCookieHandles(rvHandles, this.productHandle);

            if (this.rvHandlesToDisplay.length == 0) {
                $('.product-related-container .recently-viewed').hide();
            }
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.exists;
        }

        /**
         * Estraggo il numero di prodotti desiderati dal tag HTML specifico, se non presente prende quello di default impostato nella reset()
         */

    }, {
        key: 'getLimit',
        value: function getLimit() {
            if (this.dom.find('.js-recently-viewed .products-grid').data('products-limit')) {
                return this.dom.find('.js-recently-viewed .products-grid').data('products-limit');
            }

            return this.limit;
        }

        /**
         * Ottengo l'handle del prodotto nel tag <script></script> della Section "product-template"
         */

    }, {
        key: 'getProductHandleFromScript',
        value: function getProductHandleFromScript() {
            var handle = null;

            try {
                if ($('.ProductJsonData')) {
                    handle = $.parseJSON($('.ProductJsonData').html()).handle;
                }
            } catch (err) {
                console.error(err);
                handle = null;
            }

            return handle;
        }

        /**
         * Rimuove un Handle specifico dall'array _arrHandles
         *
         * @param {*} _arrHandles
         * @param {*} _productHandle
         */

    }, {
        key: 'removeProductHandle',
        value: function removeProductHandle(_arrHandles, _productHandle) {
            if (_productHandle !== null) {
                var index = $.inArray(_productHandle, _arrHandles);

                if (index >= 0) {
                    _arrHandles.splice(index, 1);
                }
            }

            return _arrHandles;
        }

        /**
         * Estrazione dei blocchi HTML da visualizzare tramite chiamate AJAX
         */

    }, {
        key: 'getProducts',
        value: function getProducts() {
            var self = this;
            var totalProductOk = new Array(); // Contiene le risposte delle chiamata AJAX che sono andate a buon fine
            var totalProductError = new Array(); // Contiene le risposte delle chiamate AJAX che sono andate in errore
            var indexHandleToShow = 0;

            var promises = [];

            var all = function all(array) {
                var deferred = $.Deferred();
                var fulfilled = 0,
                    length = array.length;
                var results = [];

                if (length === 0) {
                    deferred.resolve(results);
                } else {
                    array.forEach(function (promise, i) {
                        $.when(promise()).then(function (value) {
                            results[i] = value;
                            fulfilled++;
                            if (fulfilled === length) {
                                deferred.resolve(results);
                            }
                        });
                    });
                }

                return deferred.promise();
            };

            $.each(this.rvHandlesToDisplay, function (index, value) {
                promises.push(function () {
                    return $.Deferred(function (dfd) {
                        $.get('/products/' + value + '?view=related').done(function (data) {
                            /* verifico se il prodotto sia disponibile
                            cosi facendo se la chiamata mi risponde con "doctype"
                            significa che la chiamata ha avuto success ma il prodotto
                            non è disponibile */
                            if (!data.includes('doctype')) {
                                var rvProduct = $(data).html();
                                self.productRecentlyViewedHtmlElement.find('.rv-box-' + indexHandleToShow).html(rvProduct);

                                //Incremento l'indice del prossimo prodotto da inserire nell'html
                                indexHandleToShow++;

                                //Salvo la risposta nei prodotti inserito
                                totalProductOk.push({ handle: value, response: data });

                                dfd.resolve(data);
                            }
                        }).fail(function (data) {
                            var debug = false;

                            if (debug) {
                                console.group("Recently viewed - getProductInformation - Ajax Error");
                                console.warn('call KO');
                                console.warn(data);
                            }
                            console.groupEnd();

                            //Salvo la risposta nei prodotti errati
                            totalProductError.push({ handle: value, response: data });
                            dfd.resolve(data);
                        });
                    }).promise();
                });
            });

            $.when(all(promises)).then(function (data) {
                self.getProductsStatus = self.getProductStatusFromResult(totalProductOk.length, totalProductError.length);
                if (totalProductOk.length <= self.limit) {
                    self.removeHtmlElementFromIndex(totalProductOk.length);
                }

                // do something with the results
                self.dom.trigger('get-products-RecentlyViewed-after', { status: self.getProductsStatus, productsOk: totalProductOk, productsError: totalProductError });
            });
        }
    }, {
        key: 'getProductStatusFromResult',
        value: function getProductStatusFromResult(totalProductOk, totalProductError) {
            var status = this.GET_PRODUCT_STATUS_SUCCESS;

            if (totalProductOk <= 0) {
                status = this.GET_PRODUCT_STATUS_SUCCESS_NO_PRODUCTS;
            }

            if (totalProductError > 0) {
                status = this.GET_PRODUCT_STATUS_ERROR;
            }

            if (totalProductOk > 0 && totalProductError > 0) {
                status = this.GET_PRODUCT_STATUS_SUCCESS_AND_ERROR;
            }

            return status;
        }

        /**
         * Rimuove tutti gli elemnti html a partire da fromIndex
         * @param {*} fromIndex
         */

    }, {
        key: 'removeHtmlElementFromIndex',
        value: function removeHtmlElementFromIndex(fromIndex) {
            this.productRecentlyViewedHtmlElement.find('.thumbnail').eq(fromIndex).nextAll().addBack().remove();

            return true;
        }

        /**
          * Estra dal cookie gli Handle e li restituisce come array
          *
          * @returns {array}
          */

    }, {
        key: 'getProductsHandleFromCookie',
        value: function getProductsHandleFromCookie() {
            var crv = Cookies.get(this.COOKIE_NAME);
            var handles = [];

            if (crv) {
                handles = unescape(crv).split(',');
            }

            return handles;
        }

        /**
         * Salvataggio del cookie
         * * Se  "_productHandle" viene inviato lo aggiungo all'array solo se non è presente
         *
         * @param {*} _arrHandles array
         * @param {*} _productHandle
         */

    }, {
        key: 'setCookieHandles',
        value: function setCookieHandles(arrHandles) {
            var _productHandle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var cookieVal = arrHandles.join(',');

            if (_productHandle !== null) {
                var index = $.inArray(_productHandle, arrHandles);

                if (index === -1) {
                    if (arrHandles.length > 0) {
                        cookieVal = cookieVal + ',' + _productHandle;
                    } else {
                        cookieVal = _productHandle;
                    }
                }
            }

            Cookies.set(this.COOKIE_NAME, escape(cookieVal), { expires: 30, path: '/' });
        }
    }]);

    return ProductRecentlyViewed;
}();

/**
 * Oggetto per la gestione delle tab dei prodotti correlati
 *
 * Il comportamento varia in base alla presenza o meno dei prodotti raccomandati di shopify
 *
 * La tab Prodotti raccomandati da shopify verrà nascosta se non è presente la section
 *
 * Tutte le tab vuote verranno nascoste
 */


var ProductTemplate_RelatedTabs = function () {
    function ProductTemplate_RelatedTabs(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, ProductTemplate_RelatedTabs);

        this.dom = _dom;
        this.exists = this.dom && this.dom.length === 1;

        this.tabHeaderLink = this.dom.find('.related-container__tab-link');

        this.productRecommendations = null; // Oggetto per l'estrazione dei prodotti raccomandati di Shopify
        this.productRecentlyViewed = null; // Oggetto per l'estrazione dei prodotti visti di recente

        if (initOnCreate === true) {
            this.init();
        }
    }

    _createClass(ProductTemplate_RelatedTabs, [{
        key: 'init',
        value: function init() {
            if (!this.isExists) return;
            this.productRecommendations = new ProductRecommendations(this.dom);
            this.productRecentlyViewed = new ProductRecentlyViewed(this.dom);

            this.addEventHandler();

            if (this.productRecommendations.isExists()) {
                this.addEventHandlerProductReccomendations();
                this.productRecommendations.getProducts(); //La gestione della tab verrà all'intercettazione dell'evento specifico del componente
            }

            if (this.productRecentlyViewed.isExists()) {
                this.addEventHandlerProductRecentlyViewed();
                this.productRecentlyViewed.getProducts(); //La gestione della tab verrà all'intercettazione dell'evento specifico del componente
            }

            this.checkProductByBrandTab();
            this.checkProductStyledWithTab();
            this.checkProductCollectionTab();
        }

        // Destroy handler

    }, {
        key: 'destroy',
        value: function destroy() {
            this.tabHeaderLink.off('click');
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.exists;
        }

        /**
         * Select first Header Tab Visible
         * it can be called several times, based on the collections in the system
         */

    }, {
        key: 'selectFirstTabHeaderVisible',
        value: function selectFirstTabHeaderVisible() {
            this.dom.find('.tab-header:visible:first > a').click();
        }

        /**
         * Add Handler for Product Reccomendations
         *
         * * After loaded section, if not have a products, hide Tab Header and Tab Panel
         * * Call Select First Tab Visible (Because event is async, prevent no header tab seleced)
         */

    }, {
        key: 'addEventHandlerProductReccomendations',
        value: function addEventHandlerProductReccomendations() {
            var self = this;

            this.dom.on('get-products-recommendations-after', function (evt, data) {
                if (data.count == 0) {
                    self.dom.find('.recommendations.tab-header').hide();
                    self.dom.find('#related-recommendations').hide();
                }

                self.selectFirstTabHeaderVisible();
            });
        }

        /**
         * Add Handler for Product Recently Viewed (Cookie managed)
         *
         * * After loaded section, if not have a products, hide Tab Header and Tab Panel
         * * Call Select First Tab Visible (Because event is async, prevent no header tab seleced)
         */

    }, {
        key: 'addEventHandlerProductRecentlyViewed',
        value: function addEventHandlerProductRecentlyViewed() {
            var self = this;

            this.dom.on('get-products-RecentlyViewed-after', function (evt, data) {
                if (data.productsOk.length === 0) {
                    self.dom.find('.recently_viewed.tab-header').hide();
                    self.dom.find('#related-recently-viewed').hide();
                }

                self.selectFirstTabHeaderVisible();
            });
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            // Show / Hide tab, based on header clicked
            this.tabHeaderLink.on('click', function (e) {
                e.preventDefault();
                self.toggle($(this));
            });
        }

        // Hide Tab "Brand", if haven't a product(s)

    }, {
        key: 'checkProductByBrandTab',
        value: function checkProductByBrandTab() {
            if ($('#related-brand').length === 0 || $('#related-brand').find('.product-card').length === 0) {
                this.dom.find('.related-brand.tab-header').hide();
                this.dom.find('#related-brand').hide();
            }
        }

        // Hide Tab "Styled With", if haven't a product(s)

    }, {
        key: 'checkProductStyledWithTab',
        value: function checkProductStyledWithTab() {
            if ($('#related-styled-with').length === 0 || $('#related-styled-with').find('.product-card').length === 0) {
                this.dom.find('.related-styled-with.tab-header').hide();
                this.dom.find('#related-styled-with').hide();
            }
        }

        // Hide Tab "Collection", if haven't a product(s)

    }, {
        key: 'checkProductCollectionTab',
        value: function checkProductCollectionTab() {
            if ($('#related-collection').length === 0 || $('#related-collection').find('.product-card').length === 0) {
                this.dom.find('.related-collection.tab-header').hide();
                this.dom.find('#related-collection').hide();
            }
        }

        /**
         * Open / CLose panel
         * @param {Object} tabHeaderToActivate Tab Header object to activate
         */

    }, {
        key: 'toggle',
        value: function toggle(tabHeaderToActivate) {
            var contentLocation = tabHeaderToActivate.attr('href');
            if (contentLocation.charAt(0) == "#") {
                //Hedaer Tab
                this.tabHeaderLink.removeClass('active');
                tabHeaderToActivate.addClass('active');

                //Panel Tab
                this.dom.find(contentLocation).show().css({ 'display': 'block' }).addClass('active').siblings().hide().removeClass('active');
            }
        }
    }]);

    return ProductTemplate_RelatedTabs;
}();
/**
 * Gestione dello zoom immagine, se esiste il contenitore, lo sposto nel body ed attivo tutti gli handler per lo zoom
 */

var ProductTemplate_ImagesZoom = function () {
    function ProductTemplate_ImagesZoom(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var _options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, ProductTemplate_ImagesZoom);

        this.dom = _dom;
        this.zoomImages = null; // array dei div che contentono le immagini all'interno di this.dom
        this.closeZoom = $('.close-zoom');
        this.settings = null;

        if (initOnCreate == true) {
            this.init(_options);
        }
    }

    _createClass(ProductTemplate_ImagesZoom, [{
        key: 'init',
        value: function init() {
            var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.settings = $.extend(this.getDefaultSettings(), _options);
            this.exists = this.dom.length === 1;
            var currentZoomTemplate = this.dom.data('template');

            if (this.isExists()) {
                this.moveTo(this.settings.moveElementToContainer);

                if ($(this.settings.imageZoomWrapper, this.dom)) {
                    this.zoomImages = $(this.settings.imageZoomWrapper, this.dom).children();
                }

                this.addEventHandler();

                if (currentZoomTemplate == 'product-default') {
                    this.zoom();
                }
            }
        }
    }, {
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                hideClass: 'hide',
                moveElementToContainer: 'body',
                imageZoomWrapper: '.image-zoom-wrapper'
            };
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.exists;
        }

        /**
         * Muove il contenitore nel tag specifico
         * @param {string} tag
         */

    }, {
        key: 'moveTo',
        value: function moveTo(tag) {
            this.dom.appendTo($(tag));
        }

        /**
         * Visualizza il contenitore dello zoom
         * @param {integer} scrollToImage  Questo valore indica l'immagine desiderata, in base 0 ovvero 0 = prima immagine
         */

    }, {
        key: 'show',
        value: function show() {
            var scrollToImage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this.dom.removeClass(this.settings.hideClass);
            $(this.settings.imageZoomWrapper).scrollTop(this.getTopPositionShow(scrollToImage));

            scrollLock.disablePageScroll(document.querySelector(this.settings.imageZoomWrapper));
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.dom.addClass(this.settings.hideClass);

            scrollLock.enablePageScroll(document.querySelector(this.settings.imageZoomWrapper));
        }

        /**
         * estrae la top position dell'immagine richiesta
         */

    }, {
        key: 'getTopPositionShow',
        value: function getTopPositionShow(scrollToImage) {
            var topPosition = 0;

            if (this.zoomImages) {
                if (this.zoomImages.length > scrollToImage) {
                    topPosition = this.zoomImages[scrollToImage].offsetHeight * scrollToImage;
                }
            }

            return topPosition;
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            this.dom.on('click', function (e) {
                e.preventDefault();
                if ($(window).width() > SlamJam.costants.grid_large) {
                    self.hide();
                }
            });

            this.closeZoom.on('click', function (e) {
                e.preventDefault();
                self.hide();
            });
        }

        /*
         * Zoom mobile con doppio tap dello schermo usando la libreria PinchZoom.js
         */

    }, {
        key: 'zoom',
        value: function zoom() {
            if ($(window).width() < SlamJam.costants.grid_large) {

                document.addEventListener('touchmove', function (event) {
                    if (event.scale !== 1) {
                        event.preventDefault();
                    }
                }, false);

                // Array di tutte le foto del prodotto
                Array.from(document.querySelectorAll('.image-zoom-wrapper .ratio-container img')).forEach(function (el) {
                    // Inizializzo pinchZoom
                    new PinchZoom(el, {
                        tapZoomFactor: 5,
                        maxZoom: 10,
                        minZoom: 1,
                        use2d: true,
                        verticalPadding: 1,
                        draggableUnzoomed: false,
                        onZoomStart: function onZoomStart(object, event) {
                            document.querySelector('.pinch-zoom-icon').style.display = 'none';
                        },
                        onZoomEnd: function onZoomEnd(object, event) {
                            document.querySelector('.pinch-zoom-icon').style.display = 'block';
                        }
                    });
                });
            }
        }
    }]);

    return ProductTemplate_ImagesZoom;
}();

/**
 * Gestione dei controlli per la pagina prodotto
 */


var ProductTemplate = function () {
    /**
     * Fare attenzione al _dom da inserire
     *
     * IMPORTANT the third parameter "_productType" must always indicate the product type, to make the add to cart button work correctly based on the product type
     *
     * @param {*} _dom Contenitore Padre della scheda prodotto TOP, div principale della sezione Ex. section/product-template.liquid
     * @param {*} _relatedContainer  Contenitore per i prodotti Correlati, Recommended, etc......
     * @param {string} _productType  Tipologia del prodotto gestito Es. preorder, ....
     * @param {*} initOnCreate
     */

    function ProductTemplate(_dom, _relatedContainer) {
        var _productType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'standard';

        var initOnCreate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        _classCallCheck(this, ProductTemplate);

        var self = this;

        this.productType = _productType; // Tipologia di prodotto in base al nome del template
        this.dom = _dom;
        this.relatedContainer = _relatedContainer;
        this.errorMessageWrapper = this.dom.find('.error-message-wrapper');
        this.slickSliderDots = null;
        this.classCosSlickDots = 'cos-slick-dots';
        this.stopZoom = false;

        // Set json data
        if ($('.ProductJsonData')) {
            this.productJsonData = $.parseJSON($('.ProductJsonData').html());
        }

        // Bloccho informazioni prodotto
        this.productDetailsDx = $('.product-details__dx', this.dom);

        /**
         * Blocchi Add To Cart
         */

        this.blockAddToCart_Dx = this.productDetailsDx.find('.add-to-cart-wrapper'); // BLocco nelle informazioni prodotto DX
        this.addToCartStickySelector = $('#add-to-cart-sticky-wrapper', this.dom); // Blocco sticky add to cart

        this.exists = this.dom.length > 0;

        if (!this.exists) return;

        // Contenitore del breadcrumb
        this.productItemBreadcrumb = $('.breadcrumbs');

        // Immagini della galleria
        this.productSinglePhotoWrapper = $('.product-details__sx', this.dom).find('.product-single__photo-wrapper');
        this.productTemplateMedia = $('.media-template-pdp').length;

        this.productSelectVariantCollection = null; // Select presente nel blocco DX della scheda prodotto
        this.productSelectVariantCollectionSticky = null; // Select presente nel blocco sticky

        // ****************** I componenti Verranno inizializzati nella init ******************
        this.imagesZoom = new ProductTemplate_ImagesZoom($('#product-template-images-zoom', this.dom), false);

        // Il contenitore è direttamante nel template (Non deve essere inserito nella quick view) controllare che non sia inserito doppio
        this.productTemplate_RelatedTabs = new ProductTemplate_RelatedTabs(this.relatedContainer, false);

        //Ottine i form add to cart
        this.form = this.dom.find('[data-cart-form]');

        this.productTemplate_wishlistBtnWrapper = this.dom.find('.wishlist-btn-wrapper');

        this.productTemplate_AddtoCart = null; // Bottone add to cart Verrà inizializzato nella INIT
        this.addtoCartSticky = null; // Bottone add to cart sticky Verrà inizializzato nella INIT

        // Back In Stock
        this.backInStock = new BackInStock(this.blockAddToCart_Dx, false);
        this.backInStockSticky = new BackInStock(this.addToCartStickySelector, false); // Form back in stock nel blocco sticky

        /**
         * Verifica l'inserimento della kiwi size chart, indipendente dalla init del componente dato che posso inizializzarlo anche dopo, perdendo così l'observer dell'inserimento informazioni
         *
         * Modifica il testo, e rende visibile il bottone accordion
         */

        this.kiwiSizeChart = $('#KiwiSizingChart');

        this.sliderSelector = ".product-details__images";
        if (SlamJam.strings.product.abtestenable == true && SlamJam.strings.product.abtest == 'true') {
            if ($('html').attr('customer-ab') == 'groupB') {
                this.sliderSelector = ".product-details__images.groupTwo";
            } else {
                this.sliderSelector = ".product-details__images.groupOne";
            }
        }

        if (this.kiwiSizeChart.length > 0) {
            this.checkKiwiSizeChart = new CheckKiwiSizeChart(this.kiwiSizeChart);

            $(this.checkKiwiSizeChart).on(this.checkKiwiSizeChart.EVENT_KIWI_SIZE_CHART_ADDED, function (e) {
                self.kiwiSizeChart.find('._ks_text').text(self.kiwiSizeChart.data('text'));
                self.kiwiSizeChart.parent().removeClass('hide');
            });
        }

        if (initOnCreate === true) {
            this.init();
        }
    }

    _createClass(ProductTemplate, [{
        key: 'init',
        value: function init() {
            if (this.exists) {
                this.addEventHandler();
                this.setSliderImage();

                // Related Tab
                this.imagesZoom.init();
                this.productTemplate_RelatedTabs.init();

                /**
                 * Init only objects necessary for specific resolution
                 */
                if (!SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                    // Back in stock
                    this.backInStock.init();

                    this.productSelectVariantCollection = new ProductSelectVariant(this.productDetailsDx, {
                        backInStock: this.backInStock
                    });

                    this.eventsHandlerVariant();

                    this.productTemplate_AddtoCart = new AddToCartBtn(this.blockAddToCart_Dx);

                    this.addEventHandlerAddToCart();
                } else {
                    // Back in stock
                    this.backInStockSticky.init();

                    // Manage Sticky Add To Cart
                    this.productSelectVariantCollectionSticky = new ProductSelectVariant(this.addToCartStickySelector, {
                        isSticky: true,
                        backInStock: this.backInStockSticky
                    });

                    this.eventsHandlerVariantSticky();

                    var defaultAction = !this.productJsonData.available ? 'backInStock' : this.productSelectVariantCollectionSticky.getItemsCount() > 1 ? 'selectSize' : 'addToCart';

                    this.addtoCartSticky = new AddToCartBtn(this.addToCartStickySelector, {
                        isSticky: true,
                        defaultAction: defaultAction
                    });

                    this.addEventHandlerStickyAddToCart();
                }
            }
        }
    }, {
        key: 'isMobile',
        value: function isMobile() {
            return SlamJam.isMobile(SlamJam.costants.grid_large, false);
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            // handler form submit add to cart
            this.addEventHandlerOnSubmit();
        }

        //#region Submit Form Add to Cart

    }, {
        key: 'addEventHandlerOnSubmit',
        value: function addEventHandlerOnSubmit() {
            var self = this;
            this.form.off('submit');

            this.form.on('submit', function (evt) {
                evt.preventDefault();

                $('body').trigger('show-loading', {
                    handle: 'generic-loading'
                });

                // Remove any previous quantity errors
                $('.qty-error').remove();

                SlamJam.Cart.addItem($(evt.target).data('product-id'), $(evt.target).find('select[name="id"]').val(), 1, $(evt.target).data('limiter'), jQuery(evt.target).serialize(), $(evt.target).data('one-pair-per-customer'), $(evt.target).data('one-per-customer'), self.itemAddedCallback.bind(self), self.itemErrorCallback.bind(self), SlamJam.isMobile(SlamJam.costants.grid_large, false) ? null : self.itemErrorCheckLimiterCallback.bind(self));

                //console.log(evt.target);
                //console.log($(evt.target).find('select[name="id"]'));
            });
        }
    }, {
        key: 'itemAddedCallback',
        value: function itemAddedCallback(product) {
            SlamJam.minicart.refreshMinicart();

            $('body').trigger('hide-loading', {
                handle: 'generic-loading'
            });

            if (!this.isMobile()) {
                this.hideErrorAddToCartMessage();
                this.productTemplate_AddtoCart.handleAddedToCart();
            } else {
                this.addtoCartSticky.handleAddedToCart();
            }

            if (this.productJsonData.type == 'Gift Cards') {
                publish('cart-update', { source: 'product-form' }); // Gift card is successfully added to the cart, we can remove any error messages
            }
        }
    }, {
        key: 'itemErrorCallback',


        /**
         * Show error in popup when mobile resolution, otherwise into div
         * @param {*} XMLHttpRequest
         * @param {*} textStatus
         */

        value: function itemErrorCallback(XMLHttpRequest, textStatus) {
            $('body').trigger('hide-loading', { handle: 'generic-loading' });
            var data = eval('(' + XMLHttpRequest.responseText + ')');

            if (!this.isMobile()) {
                if (!!data.message) {
                    if (data.status == 422 || data.status == "bad_request") {
                        this.showErrorAddToCartMessage(data.description);
                    }
                }
            } else {
                SlamJam.showPopUpErrorFromAjaxRequest(XMLHttpRequest);
            }

            // If the product is a gift card execute the recipient form error callback
            if (this.productJsonData.type == 'Gift Cards') {
                publish('cart-error', {
                    source: 'product-form',
                    errors: data.errors || data.description,
                    message: data.message
                });
            }
        }
    }, {
        key: 'itemErrorCheckLimiterCallback',
        value: function itemErrorCheckLimiterCallback() {
            this.errorMessageWrapper.html(SlamJam.strings.addToCart_limitQty_reached).addClass('visible');
        }
    }, {
        key: 'showErrorAddToCartMessage',
        value: function showErrorAddToCartMessage(message) {
            this.errorMessageWrapper.html(message).addClass('visible');
        }
    }, {
        key: 'hideErrorAddToCartMessage',
        value: function hideErrorAddToCartMessage() {
            this.errorMessageWrapper.removeClass('visible').html('');
        }
        //#endregion

        // Eventi per la select taglie blocco DX

    }, {
        key: 'eventsHandlerVariant',
        value: function eventsHandlerVariant() {
            var self = this;

            $(this.productSelectVariantCollection).on('selected-variant', function (e) {
                self.blockAddToCart_Dx.find('.BIS_response_success').hide();
                self.blockAddToCart_Dx.find('.BIS_response_error').hide();
                self.hideErrorAddToCartMessage();

                self.productTemplate_AddtoCart.resetButton();
            });
        }

        // Eventi per la select taglie sticky

    }, {
        key: 'eventsHandlerVariantSticky',
        value: function eventsHandlerVariantSticky() {
            var self = this;

            $(this.productSelectVariantCollectionSticky).on('BIS_response_success', function (e) {
                self.productSelectVariantCollectionSticky.enableItemsIfVariantNotAvailable();
            });

            $(this.productSelectVariantCollectionSticky).on('select-variant-dropdown-opened', function (e) {
                self.addToCartStickySelector.find('.BIS_response_success').hide();
                self.addToCartStickySelector.find('.BIS_response_error').hide();
            });

            $(this.productSelectVariantCollectionSticky).on('select-variant-dropdown-closed', function (e) {
                self.addToCartStickySelector.find('.BIS_response_success').hide();
                self.addToCartStickySelector.find('.BIS_response_error').hide();
            });

            $(this.productSelectVariantCollectionSticky).on('selected-variant', function (e, itemClicked, variantId) {
                if ($(itemClicked).data('show-back-in-stock') !== true) {
                    self.addtoCartSticky.stickyAddToCart(variantId);
                }
            });
        }

        /**
         * Imposta gli handler pe gestire lo zoom immagini invocata dopo aver impostato i dots dello slider
         */

    }, {
        key: 'addEventHandlerToZoomImage',
        value: function addEventHandlerToZoomImage() {
            var self = this;
            this.productSinglePhotoWrapper.off('click');
            this.productSinglePhotoWrapper.on('mouseup', function (e) {
                e.preventDefault();

                if (!self.stopZoom) {
                    self.imagesZoom.show(self.slickSliderDots.getCurSlide(true));
                }
            });
        }

        // Gestione eventi per bottone add to cart

    }, {
        key: 'addEventHandlerAddToCart',
        value: function addEventHandlerAddToCart() {
            var self = this;

            // Se il bottone è add to cart devo fare i toggle della selezione taglia
            $(this.productTemplate_AddtoCart).on(this.productTemplate_AddtoCart.EVENT_BTN_ADD_TO_CART_CLICK, function (e) {
                // Non serve lanciare la set variantid, perchè vienbe eseguita direttamente dalla select item click
                self.productTemplate_AddtoCart.addToCart();
            });

            //
            $(this.productTemplate_AddtoCart).on(this.productTemplate_AddtoCart.EVENT_BTN_PREORDER_CLICK, function (e) {
                // Non serve lanciare la set variantid, perchè vienbe eseguita direttamente dalla select item click
                self.productTemplate_AddtoCart.addToCart();
            });

            // Se il bottone è Show cart devo fare il redirect
            $(this.productTemplate_AddtoCart).on(this.productTemplate_AddtoCart.EVENT_BTN_VIEW_CART_CLICK, function (e) {
                //  SlamJam.pageRedirect('/cart');
                window.location.href = window.origin + '/cart';
            });
        }

        // Gestione eventi per bottone add to cart sticky

    }, {
        key: 'addEventHandlerStickyAddToCart',
        value: function addEventHandlerStickyAddToCart() {
            var self = this;

            $(this.addtoCartSticky).on(this.addtoCartSticky.EVENT_BTN_SELECT_SIZE_CLICK, function (e) {
                self.toggleProductSelectVariantSticky();
            });

            $(this.addtoCartSticky).on(this.addtoCartSticky.EVENT_BTN_BACKINSTOCK_CLICK, function (e) {
                self.toggleProductSelectVariantSticky();
            });

            // Se il bottone è Show cart devo fare il redirect
            $(this.addtoCartSticky).on(this.addtoCartSticky.EVENT_BTN_VIEW_CART_CLICK, function (e) {
                //  SlamJam.pageRedirect('/cart');
                window.location.href = window.origin + '/cart';
            });

            // Se il bottone è add to cart devo fare i toggle della selezione taglia
            $(this.addtoCartSticky).on(this.addtoCartSticky.EVENT_BTN_ADD_TO_CART_CLICK, function (e) {
                // Non serve lanciare la set variantid, perchè vienbe eseguita direttamente dalla select item click
                if (SlamJam.strings.product.general.is_one_size == true) {
                    self.addtoCartSticky.addToCart();
                } else {
                    self.toggleProductSelectVariantSticky();
                }
            });
        }
    }, {
        key: 'toggleProductSelectVariantSticky',
        value: function toggleProductSelectVariantSticky() {
            if (this.productSelectVariantCollectionSticky.isOpened) {
                this.productSelectVariantCollectionSticky.closeDropdown();
            } else {
                SlamJam.strings.product.general.is_one_size == false ? this.productSelectVariantCollectionSticky.openDropdown() : $(this.productSelectVariantCollectionSticky.dropdownItems[0]).trigger('click');
            }
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.exists;
        }

        //Imposta le coordinate per l'elemento sticky solo se sono in visualizzazione desktop

    }, {
        key: 'setStickyElement',
        value: function setStickyElement() {
            if (this.exists && !SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                var offsetTop = 120;

                if ($('.site-header__helloBar').hasClass('helloBar__show')) {
                    $('.product-details__dx', this.dom).css('top', 'unset');
                }

                if (this.productItemBreadcrumb.length == 0) {
                    offsetTop = offsetTop - 40;
                }

                $('.product-details__dx', this.dom).stick_in_parent({ 'inner_scrolling': false, 'offset_top': offsetTop });
            }

            return true;
        }

        //Avvia il ricalcolo dello sticky element utilizzando l'evento della libreria JS usata

    }, {
        key: 'stickyRecalc',
        value: function stickyRecalc() {
            if (this.exists) {
                $('.template-product .product-details__dx', this.dom).trigger('sticky_kit:recalc');
            }
        }
    }, {
        key: 'unsetStickyElement',
        value: function unsetStickyElement() {
            if (this.exists) {
                $('.template-product .product-details__dx', this.dom).trigger('sticky_kit:detach');
            }
        }

        //Crea Slick Slider per le immagini, e nasconde i dots e le frecce se è presente una sola immagine

    }, {
        key: 'setSliderImage',
        value: function setSliderImage() {
            this.stopZoom = false;

            if (this.exists) {
                var TotalImages = this.productSinglePhotoWrapper.length;

                var settings = {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                };

                if (TotalImages > 1) {
                    if (this.productTemplateMedia) {
                        var _$$extend;

                        settings = $.extend(settings, (_$$extend = {
                            dots: true,
                            customPaging: this.customPaging.bind(this),
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            accessibility: false,
                            swipe: false,
                            draggable: false
                        }, _defineProperty(_$$extend, 'swipe', false), _defineProperty(_$$extend, 'swipeToSlide', false), _defineProperty(_$$extend, 'touchMove', false), _defineProperty(_$$extend, 'draggable', false), _defineProperty(_$$extend, 'infinite', true), _defineProperty(_$$extend, 'prevArrow', '<button type="button" class="slick-arrow slick-arrow-prev">' + $('#caretImage').html() + '</button>'), _defineProperty(_$$extend, 'nextArrow', '<button type="button" class="slick-arrow slick-arrow-next">' + $('#caretImage').html() + '</button>'), _$$extend));
                    } else {
                        settings = $.extend(settings, {
                            dots: true,
                            customPaging: this.customPaging.bind(this),
                            arrows: true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: true,
                            prevArrow: '<button type="button" class="slick-arrow slick-arrow-prev">' + $('#caretImage').html() + '</button>',
                            nextArrow: '<button type="button" class="slick-arrow slick-arrow-next">' + $('#caretImage').html() + '</button>'
                        });
                    }
                }

                $(this.sliderSelector, this.dom).on('init', this.onSlickInit.bind(this)).on('beforeChange', this.onBeforeChangeSlide.bind(this)).on('afterChange', this.onAfterChangeSlide.bind(this)).on('mousedown', this.onMouseDownChangeSlide.bind(this)).slick(settings);
            }
        }
    }, {
        key: 'unsetSliderImage',
        value: function unsetSliderImage() {
            $(this.sliderSelector, this.dom).slick('unslick');
        }

        /**
         * Gestisce i dots che si colorano in alto alla foto
         * @param {*} slider
         * @param {*} i
         */

    }, {
        key: 'customPaging',
        value: function customPaging(slider, i) {
            var totalSlide = slider.$slides.length;
            var currentSlide = i + 1;
            var numberSLide = currentSlide;
            var cssClass = this.classCosSlickDots;
            var classMatch = false;

            if (slider.$slides[i].className.match("groupOne")) {
                classMatch = slider.$slides[i].className.match("groupOne")[0];
            }
            if (slider.$slides[i].className.match("groupTwo")) {
                classMatch = slider.$slides[i].className.match("groupTwo")[0];
            }

            if (currentSlide < 10) {
                numberSLide = "0" + numberSLide;
            }

            if (currentSlide == 1) {
                cssClass = cssClass + ' colored';
            }

            return '<button type="button" class="' + cssClass + ' ' + classMatch + '" role="tab" id="slick-slide-control-' + numberSLide + '" aria-controls="slick-slide' + numberSLide + '" aria-label="' + numberSLide + ' of ' + totalSlide + '" tabindex="-1" style="width: 100%;">' + currentSlide + '</button>';
        }
    }, {
        key: 'onSlickInit',
        value: function onSlickInit() {
            // Reset position, for resolve bugfix
            $(this.sliderSelector, this.dom).find('.product-single__photo--flex-wrapper').css('position', 'relative');
            this.setSlickDots();
        }

        //Crea gli oggetti dei dots che hanno la loro logica esteerna alla classe dello slider

    }, {
        key: 'setSlickDots',
        value: function setSlickDots() {
            this.stopZoom = false;
            this.slickSliderDots = new SlickSliderDots($(this.sliderSelector, this.dom), this.classCosSlickDots);
            this.addEventHandlerToZoomImage();
        }
    }, {
        key: 'gotToSlide',
        value: function gotToSlide(slide) {
            this.slickSliderDots.setSlide(slide);
        }
    }, {
        key: 'onAfterChangeSlide',
        value: function onAfterChangeSlide(event, slick, currentSlide) {
            this.gotToSlide(currentSlide);
        }
    }, {
        key: 'onBeforeChangeSlide',
        value: function onBeforeChangeSlide(event, slick, currentSlide) {
            //Elimino l'overlay di eventuali messaggi in pdp
            $('.product-details__image-overlay').remove();
        }
    }, {
        key: 'onMouseDownChangeSlide',
        value: function onMouseDownChangeSlide(event) {
            var self = this;
            var ct = $(event.currentTarget);

            //Elimino l'overlay di eventuali messaggi in pdp
            $('.product-details__image-overlay').remove();

            $(event.currentTarget).on('mousemove', function (e) {
                self.stopZoom = true;
            });

            $(event.currentTarget).off('mouseup');

            $(event.currentTarget).on('mouseup', function (e) {
                self.stopZoom = false;
                ct.off('mousemove');
            });
        }
    }]);

    return ProductTemplate;
}();